import React from "react";
import {
    cancelFileUploadJob,
    getFeConfig,
    insertNewRefTableData,
    submitRefTableData,
    visualizeLoadCustomDutyNorway,
    uploadNorwayCustomDutyFile,
    visualizeWithFilter
} from "../../api/api";
import {TableV2, TableOperation} from "@q4us-sw/q4us-ui/lib/TableV2";
import {TableFilter} from "../filters/TableFilter";
import {
    Alert,
    Button, Divider,
    Modal,
    notification,
    Select, Spin, Table as TableAntd, Typography
} from "antd";
import {AppstoreAddOutlined, UploadOutlined} from "@ant-design/icons";
import {Header} from "../generic/Header";
import {Form} from "@q4us-sw/q4us-ui";
import moment from "moment";
import {MapToFilter} from "../../utils/mappings";
import {Fileset, ProgressView, StandardRate} from "./CustomsDutyRates";
import {unstable_batchedUpdates} from "react-dom";
import {EditCell} from "@q4us-sw/q4us-ui/lib/Cell";

const { Option } = Select;

const ProgressContext = React.createContext();

const CountrySelect = (props) => {
    const [nonEUConfig, setNonEUConfig] = React.useState([]);
    const load = async ()=>{
        const {data = {}} = await getFeConfig('customs_duty_supported_non_eu_country') || {};
        const { rows = [] } = data;

        setNonEUConfig(rows[0].enums);
    }

    React.useEffect(()=>{
        load();
    },[])

    return <EditCell type={'STRING'} enums={nonEUConfig} onChange={(e)=>{props.onChangeCountry(e)}} />;
};

export const UploadFileset = (props) => {
    const [open, setOpen] = React.useState(false)
    const [info, setInfo] = React.useState(undefined)
    const [err, setErr] = React.useState(undefined)

    return <React.Fragment>
        <Button style={{width: 160}} icon={<UploadOutlined/>} onClick={() => {
            setOpen(true)
        }}>Upload Files</Button>
        {open && <Modal
            centered
            closable={true}
            width={650}
            onCancel={() => {
                unstable_batchedUpdates(()=>{
                    setOpen(false)
                    setInfo(undefined)
                    setErr(undefined)
                })

            }}
            footer={null}
            title={`Custom Duty Rate File Upload - NO`}
            visible={open}
        >
            <ProgressView onCancel={async (id)=> {cancelFileUploadJob(({id, 'data_type':'country_customs_duty_rate_non_eu_no' }))}}
                          fetch={ async () => {
                              const {data: {rows: [first] = []}} = await visualizeWithFilter({
                                  tableName: "file_upload_job",
                                  conditions: [{key: "type", value: 'country_customs_duty_rate_non_eu_no'}, {key: "status", value: 'pending'}]
                              });
                              return first
                          }}
                          onSuccess={async (id, progress, response)=>{
                              cancelFileUploadJob({id, data_type:'country_customs_duty_rate_non_eu_no'})
                              setInfo({
                                  message:"Custom Duty Rates uploaded successfully",
                                  descTitle: `${response['noOfRowsUploaded']} record(s) out of  ${response['noOfRows']} records(s) uploaded`,
                                  type:"success",
                                  showIcon: true
                              })
                              setErr(response['errors'])
                          }}>
                <ProgressContext.Consumer>
                    {p => <Spin spinning={p?.value?.progress !== undefined && p?.value?.progress !== 100}>
                        <Fileset extension={".json"} files={[{fileId: "duties_rate", title: "Duties rates File"}, {fileId: "countries_groups_reference", title: "Countries groups reference"},
                            {fileId: "hs_code_description", title: "HS code descriptions"},]} onReady={async ({content:file, files}) => {
                            const zipFile = new File([file], 'test.zip', {type: "zip"});
                            setInfo({
                                message: "Files uploading .....",
                                type:"info",
                                showIcon: true,
                                descTitle: "Uploading files ...",
                                desc: files.map(o=>`${o.title} : ${o.file.file.name}`)
                            })
                            const formData = new FormData();
                            formData.append('data_type', 'country_customs_duty_rate_non_eu_no');
                            formData.append('file', zipFile);
                            try {
                                const res = await uploadNorwayCustomDutyFile(formData)

                                if(res && res.status === 200){
                                    const {data:[first]} = res
                                    const {errorList, status, errorMsg = "Error in file Uploading!"} = first || {}
                                    if(status === 'error') {
                                        throw {message: errorMsg}
                                    }
                                    unstable_batchedUpdates(()=>{
                                        setErr(errorList)
                                        setInfo({
                                            message: "File upload job created...",
                                            type: "info",
                                            showIcon: true
                                        })
                                    })
                                }
                                else {
                                    throw {message: 'Error in file uploading'}
                                }

                            }catch (e){
                                setInfo({
                                    message: e.message,
                                    type: "error",
                                    showIcon: true
                                })
                            }
                            p?.init()
                        }
                        }/>
                    </Spin>}
                </ProgressContext.Consumer>
                {info  && <Alert {...info} description={<React.Fragment>
                    {info.descTitle && <Typography.Text>{info.descTitle}</Typography.Text>}
                    {info.desc && <ol>{info.desc.map(o=><li>{o}</li>)}</ol>}
                    {err && <TableAntd dataSource={err} size={'small'}>
                        <TableAntd.Column title={"Error Type"} dataIndex={"error"}/>
                        <TableAntd.Column title={"Field"} dataIndex={"column"}/>
                        <TableAntd.Column title={"No. of Occurrences"} dataIndex={"occurrence"}/>
                    </TableAntd>}

                </React.Fragment>}/>}

            </ProgressView>

        </Modal>}
    </React.Fragment>
}

export const CustomsDutyRatesNonEU  = (props)=>{

    const [open, setOpen] = React.useState(false);
    const [selectedCountry, setSelectedCountry] = React.useState('no');

    const loadData = React.useCallback(async (filters = {}, page = {})=>{
        const _filters = MapToFilter(filters)
        return await visualizeLoadCustomDutyNorway({
            tableName: `country_customs_duty_rate_non_eu_${selectedCountry}`,
            orderBy: ['id desc'],
            filter:[..._filters],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }, [selectedCountry])


    return <React.Fragment>

            <TableV2
                key = {selectedCountry}
                schema={selectedCountry}
                action={{
                    name: 'id',
                    title: 'Action',
                    options: TableOperation.Update,
                }}
                maxColumnWidth={400}
                customRenderer={{
                    "end_date": (value) => value ? moment(value).format("YYYY-MM-DD") : "",
                    "start_date": (value) => value ? moment(value).format("YYYY-MM-DD") : ""}}
                shouldRefresh={(operation, status)=> {return operation === TableOperation.Update}}

                fetchConfig={async (schema) => {
                    const { data = {} } = await getFeConfig(`country_customs_duty_rate_non_eu_${schema}`)
                    const { statusCode, rows = [], fields = [] } = data;
                    return { data: { statusCode, rows: rows, fields } };
                }}

                fetchData={async (request) => {
                    return await loadData(request.options.filter || {}, request.page)
                }}
                scroll={{y: 'calc(100vh - 325px)', x: 'max-content' }}
                saveData={async (data) => {
                    data['timestamp'] = new Date().toUTCString();
                    const { data: { statusCode = 400, rows = [] } = {} } = await submitRefTableData(data, `country_customs_duty_rate_non_eu_${selectedCountry}`);
                    return { data: { statusCode, rows: [data] } };
                }}

                header={
                    <Header title={`Non-EU Customs Duty Rate - ${selectedCountry.toUpperCase()}`} actions={<div className={`action-items`}>

                        <StandardRate value={0} name={`standard_rate_${selectedCountry.toUpperCase()}`} />
                        <Divider type={"vertical"} key={"sep"}/>
                        <CountrySelect onChangeCountry={(country) =>{setSelectedCountry(country.toLowerCase())}} />
                        <UploadFileset key={`upload_${selectedCountry}`} dataType={`custom_duty_rate_non_eu_${selectedCountry}`}/>
                        <Button key={`add_${selectedCountry}`} style={{width: 160}} icon={<AppstoreAddOutlined/>} onClick={() => setOpen(true)}>Add New Record</Button>

                    </div>} childHeight={80}>
                        <TableFilter schema={`country_customs_duty_rate_non_eu_filter_${selectedCountry}`} fetch={loadData}/>
                    </Header>
                }
            />

        <Modal
            centered
            closable={true}
            onCancel={() => setOpen(false)}
            footer={null}
            title={`Add new Record`}
            visible={open}
        >
            <Form maxHeight={`60vh`} schema={`country_customs_duty_rate_non_eu_form_${selectedCountry}`} config={async (schema) => {
                const res = await getFeConfig(schema) || {}
                const {data: {rows = []} = {}} = res;
                return rows.map(o => o.name === "hs6p_code" ? {
                    ...o,
                    format: {regex: /\D/g, format: ''},
                    mask: {regex: /^(\d{4})(\d{1,2})/g, format: '$1 $2 '}
                } : o);
            }}
                  validateField={async  (rule, value, schema, column, form) =>{
                      if(column.name === 'customs_duty'){
                          const dob = form.getFieldsValue(['customs_duty']) || {};
                          if(dob['customs_duty'] < 0)
                              return Promise.reject(
                                  'Duty cannot be negative'
                              )
                      } else if (column.name === 'end_date') {
                          const endDate = form.getFieldsValue(['end_date']) || {};
                          const date = moment(endDate['end_date']);
                          if(moment().diff(date) > 0)
                              return Promise.reject(
                                  'End date cannot be less than the current date '
                              )
                      }
                      return Promise.resolve()
                  }}
                  submit={async (values) => {
                      values['hs6p_code'] = values['hs6p_code'].replace(/\D/g, '')
                      const { data } = await insertNewRefTableData(values, `country_customs_duty_rate_non_eu_${selectedCountry}`);
                      if (data.statusCode === 200) {
                          notification.success({message: `New customs duty rate added to ${selectedCountry.toUpperCase()}`})
                      }
                      return true;
                  }}/>
        </Modal>

    </React.Fragment>
}
